module.exports = __webpack_public_path__ + "img/fullscreen.4f4d4867.svg";